import { render, staticRenderFns } from "./RoleComponent.vue?vue&type=template&id=59d8bb58&scoped=true"
import script from "./RoleComponent.vue?vue&type=script&lang=js"
export * from "./RoleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8bb58",
  null
  
)

export default component.exports